import NotFount from '@/common/components/Empty';

const style = { height: '100vh' };

const NoPage = () => {
  return (
    <div style={style}>
      <NotFount />
    </div>
  );
};

export default NoPage;
